// import Input from '../../../../components/Input';
import { useEffect, useState } from 'react';
import { Button, Modal, PasswordInput, TextInput } from '@mantine/core';
import type { FcaCredentialsResponse } from '../../FCA/hooks/types';
import { Container } from './style';

interface FCACredentialsModalProps {
  id?: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (username: string, password: string) => void;
  onDelete: () => void;
  isLoading: boolean;
  isLoadingDelete: boolean;
  credentials?: FcaCredentialsResponse | null;
}
export function FCACredentialsModal({
  id,
  isOpen,
  onClose,
  onSubmit,
  onDelete,
  isLoading,
  credentials,
  isLoadingDelete
}: FCACredentialsModalProps) {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  useEffect(() => {
    if (credentials) {
      setUsername(credentials.username);
    }
  }, [credentials, isOpen]);

  return (
    <Modal
      id={id ?? 'fca-credentials-modal'}
      title="FCA API Credentials"
      closeOnClickOutside={false}
      centered
      size="sm"
      opened={isOpen}
      onClose={onClose}
    >
      <Container id="fca-credentials-modal-container">
        <form id="fca-credentials-modal-form">
          <TextInput
            id="fca-credentials-modal-username-input"
            value={username}
            onChange={e => setUsername(e.target.value)}
            // boxClass="box"
            label="Username"
            placeholder="Write your username"
          />
          <PasswordInput
            id="fca-credentials-modal-password-input"
            value={password}
            onChange={e => setPassword(e.target.value)}
            // type="password"
            // boxClass="box"
            label="Password"
            placeholder="Write your password"
          />
        </form>
        <div className="actions" id="fca-credentials-modal-actions">
          {!!credentials && (
            <Button
              id="fca-credentials-modal-delete-button"
              w="50%"
              variant="outline"
              onClick={onDelete}
              size="sm"
              loading={isLoadingDelete}
              color="red"
            >
              Delete Credentials
            </Button>
          )}
          {!credentials && (
            <Button
              id="fca-credentials-modal-cancel-button"
              w="50%"
              variant="outline"
              size="sm"
              onClick={onClose}
            >
              Cancel
            </Button>
          )}
          {!credentials && (
            <Button
              id="fca-credentials-modal-test-connection-button"
              w="50%"
              size="sm"
              onClick={() => onSubmit(username, password)}
              loading={isLoading}
            >
              Test Connection
            </Button>
          )}

          {credentials && (
            <Button
              id="fca-credentials-modal-update-button"
              w="50%"
              size="sm"
              onClick={() => onSubmit(username, password)}
              loading={isLoading}
            >
              Update
            </Button>
          )}
        </div>
      </Container>
    </Modal>
  );
}
